import { combineEpics } from 'redux-observable';

import { loadCollections } from './loadCollections';
import { removeCollection } from './removeCollection';
import { createCollection } from './createCollection';
import { editCollection } from './editCollection';

export default combineEpics(
  loadCollections,
  removeCollection,
  createCollection,
  editCollection,
);



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/epics/index.ts